<template>
  <div>
    <div id="goback" style="margin-bottom: 10px; font-size: 14px">
      <i class="el-icon-back" @click="$router.go(-1)" style="cursor: pointer"
        >返回</i
      >&nbsp;&nbsp;
      <span style="font-size: 14px; color: rgb(192, 196, 204)">|</span>
      &nbsp;&nbsp;<span style="color: rgb(192, 196, 204)">编号：</span
      >{{ pcode }} <span style="color: rgb(192, 196, 204)">项目：</span
      >{{ pname }}
    </div>
    <div id="content">
      <div class="op">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-zoom-in"
          @click="operate('新建', null, null)"
          :disabled="doing"
          >创建报告</el-button
        >
        <el-button
          size="small"          
          type="info"
          plain
          icon="el-icon-copy-document"
          @click="openBatchAdd"
          :disabled="doing"
          >批量创建报告</el-button
        >
        <el-button
          size="small"
          type="info"
          plain
          icon="el-icon-s-data"
          @click="openBatchKpi"
          :disabled="doing"
          >批量生成kpi</el-button
        >
        <el-button
          size="small"
          type="info"
          plain
          icon="el-icon-download"
          @click="batchDownKpi"
          :disabled="doing || downLoading"
          :loading="downLoading && downType === 'kpi'"
          >下载kpi</el-button
        >
        <el-button
          size="small"
          type="info"
          plain
          icon="el-icon-download"
          @click="batchDownZuhe"
          :disabled="doing || downLoading"
          :loading="downLoading && downType === 'zuhe'"
          >下载组合题</el-button
        >
        <el-button
          size="small"
          type="info"
          plain
          icon="el-icon-download"
          @click="batchDownLoudou"
          :disabled="doing || downLoading"
          :loading="downLoading && downType === 'loudou'"
          >下载漏斗题</el-button
        >
        <el-button
          size="small"
          type="info"
          plain
          icon="el-icon-view"
          @click="topage('kpipv')"
          :disabled="doing"
          >PV 浏览</el-button
        >
      </div>
      <div class="plist">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="id" v-if="false"> </el-table-column>
          <el-table-column prop="name" label="报告名称" width="300">
            <template slot-scope="scope">
              {{ scope.row.name}}<span v-if="scope.row.moren" class="moren">默认</span><span v-if="scope.row.open" class="open">开放浏览</span>
            </template>
          </el-table-column>
          <el-table-column prop="database" label="base" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.database" class="base-tag">{{ scope.row.database }}</span>
              <span v-else class="no-base">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="550">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'kpi',
                  params: {
                    pid: pid,
                    kid: scope.row.id,
                    bname: scope.row.name,
                    pname: pname,
                    pcode: pcode,
                  },
                }"
                class="caozuo"
                >查看</router-link
              >
              <router-link
                :to="{
                  name: 'quotatab',
                  params: {
                    pid: pid,
                    kid: scope.row.id,
                    bname: scope.row.name,
                    pname: pname,
                    pcode: pcode,
                  },
                }"
                class="caozuo"
                >配额表</router-link
              >
         
              <router-link
                :to="{
                  name: 'quotarun',
                  params: {
                    pid: pid,
                    kid: scope.row.id,
                    bname: scope.row.name,
                    pname: pname,
                    pcode: pcode,
                  },
                }"
                class="caozuo"
                >撞数</router-link
              >
              <el-button
                round
                size="mini"
                @click="operate('复制', scope.row.name, scope.row.id)"
                class="result"
                :disabled="doing"
                >复制</el-button
              >
              <el-button
                round
                size="mini"
                @click="operate('重命名', scope.row.name, scope.row.id)"
                class="result"
                :disabled="doing"
                >重命名</el-button
              >
 <el-button
                round
                size="mini"
                @click="operateChartImport(scope.row.name, scope.row.id)"
                class="result"
                :disabled="doing"
                >表头表侧</el-button
              >
              <el-button
                :disabled="doing"
                type="danger"
                round
                size="mini"
                @click="del(scope.row.id)"
                class="result"
                plain
                >删除</el-button
              >
             
            </template>
          </el-table-column>
          <el-table-column prop="created_time" label="创建日期">
            <template slot-scope="scope">
              <div :style="{ color: '#c0c4cc', 'font-size': '12px' }">
                {{ scope.row.created_time }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fenye">
        <el-pagination
          @current-change="getreport"
          :current-page.sync="currentPage"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 表头表侧上传弹窗 -->
    <el-dialog title="表头表侧" :visible.sync="chartImportDialogVisible" width="500px" :before-close="handleChartImportClose">
      <div class="upload-container">
        <el-upload
          class="upload-demo"
          :action="uploadAction"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :headers="uploadHeaders"
          :data="{ pid: pid, kid: currentKid }"
          :auto-upload="false"
          :show-file-list="showFileList"
          accept=".xlsx,.xls"
          :before-upload="beforeAvatarUpload"
          ref="uploadRef"
          :limit="1"
        >
          <div class="upload-area">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件</div>
            <div class="el-upload__tip" slot="tip">导入的excel中要包含"表头"和"表侧"两个表，每个表中的数据格式保持跟datamap一致</div>
          </div>
        </el-upload>
        <div class="button-group" style="margin-top: 20px;">
          <el-button type="primary" @click="submitUpload" icon="el-icon-upload2" :loading="uploadLoading">导入生成</el-button>
          <el-button @click="clearHeader" icon="el-icon-delete" :loading="clearLoading.header">清除表头</el-button>
          <el-button @click="clearSide" icon="el-icon-delete" :loading="clearLoading.side">清除表侧</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleChartImportClose">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 批量创建reportal弹窗 -->
    <el-dialog title="批量创建reportal" :visible.sync="batchDialogVisible" width="500px" :before-close="handleBatchClose">
      <div v-loading="batchDataLoading" element-loading-text="数据加载中...">
        <el-form label-width="120px" size="small">
          <el-form-item label="数据筛选题目">
            <el-select v-model="batchForm.qid" placeholder="请选择筛选题目" style="width: 100%" filterable :disabled="batchDataLoading">
              <el-option
                v-for="item in batchQids"
                :key="item.qid"
                :label="item.qid + ' ' + item.qlabel"
                :value="item.qid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板reportal">
            <el-select v-model="batchForm.cpid" placeholder="请选择模板reportal" style="width: 100%" filterable :disabled="batchDataLoading">
              <el-option
                v-for="item in batchReports"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleBatchClose" :disabled="batchDataLoading">取 消</el-button>
        <el-button type="primary" @click="submitBatchAdd" :loading="batchLoading" :disabled="batchDataLoading">立即创建</el-button>
      </span>
    </el-dialog>
    <!-- 批量生成kpi弹窗 -->
    <el-dialog
      :title="batchKpiRunning ? '批量生成KPI - 运行中' : batchKpiJustFinished ? '批量生成KPI - 已完成' : '批量生成KPI'"
      :visible.sync="batchKpiDialogVisible"
      width="680px"
      :before-close="handleBatchKpiClose"
      :close-on-click-modal="false"
      custom-class="batch-kpi-dialog"
    >
      <div v-loading="batchKpiLoading" element-loading-text="加载中...">
        <div v-if="!batchKpiLoading">
          <!-- 进度面板：运行中或本次刚完成时显示 -->
          <div v-if="batchKpiRunning || batchKpiJustFinished" class="batch-progress-panel">
            <div class="progress-header">
              <div class="progress-stats">
                <div class="stat-item">
                  <span class="stat-value">{{ batchKpiStatus.total }}</span>
                  <span class="stat-label">总计</span>
                </div>
                <div class="stat-item stat-success">
                  <span class="stat-value">{{ batchKpiRunning ? batchKpiStatus.current - 1 - batchKpiFailedCount : batchKpiStatus.current - batchKpiFailedCount }}</span>
                  <span class="stat-label">已完成</span>
                </div>
                <div class="stat-item stat-danger" v-if="batchKpiFailedCount > 0">
                  <span class="stat-value">{{ batchKpiFailedCount }}</span>
                  <span class="stat-label">失败</span>
                </div>
                <div class="stat-item stat-primary" v-if="batchKpiRunning">
                  <span class="stat-value">{{ batchKpiStatus.total - batchKpiStatus.current }}</span>
                  <span class="stat-label">待执行</span>
                </div>
              </div>
            </div>
            <el-progress
              :percentage="batchKpiStatus.total > 0 ? Math.round((batchKpiStatus.current / batchKpiStatus.total) * 100) : 0"
              :status="batchKpiStatus.status === 'completed' ? 'success' : batchKpiStatus.status === 'failed' ? 'exception' : undefined"
              :stroke-width="18"
              :text-inside="true"
              style="margin: 12px 0"
            ></el-progress>
            <div v-if="batchKpiRunning && batchKpiStatus.currentKid" class="current-running">
              <i class="el-icon-loading"></i>
              <span>正在执行: <strong>{{ getReportName(batchKpiStatus.currentKid) }}</strong></span>
            </div>
            <div v-if="!batchKpiRunning && batchKpiStatus.message" class="status-message" :class="'status-' + batchKpiStatus.status">
              <i :class="batchKpiStatus.status === 'completed' ? 'el-icon-circle-check' : 'el-icon-circle-close'"></i>
              {{ batchKpiStatus.message }}
            </div>
          </div>

          <!-- 选择区域：非运行中且非本次刚完成时显示 -->
          <div class="batch-select-area" v-if="!batchKpiRunning && !batchKpiJustFinished">
            <div class="select-toolbar">
              <el-checkbox v-model="checkAll" @change="handleCheckAllChange" :indeterminate="isIndeterminate">全选</el-checkbox>
              <span class="select-count">已选 <em>{{ batchKpiForm.kids.length }}</em> / {{ batchKpiReports.length }} 个</span>
            </div>
            <div class="report-check-list">
              <el-checkbox-group v-model="batchKpiForm.kids">
                <div v-for="item in batchKpiReports" :key="item.id" class="report-check-item">
                  <el-checkbox :label="item.id">
                    <span class="report-check-name">{{ item.name }}</span>
                    <span v-if="item.database" class="report-check-base">{{ item.database }}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
              <div v-if="batchKpiReports.length === 0" class="empty-tip">暂无reportal数据</div>
            </div>
          </div>

          <!-- 运行中/本次刚完成后的报告状态列表 -->
          <div v-if="batchKpiRunning || batchKpiJustFinished" class="batch-status-list">
            <div class="status-list-header">
              <span>报告列表</span>
              <span class="status-list-summary">{{ batchKpiStatus.current }} / {{ batchKpiStatus.total }} 已处理</span>
            </div>
            <div class="status-list-body">
              <div
                v-for="(item, index) in batchKpiReports"
                :key="item.id"
                class="status-list-item"
                :class="getItemStatusClass(item.id)"
              >
                <span class="item-index">{{ index + 1 }}</span>
                <span class="item-name">{{ item.name }}</span>
                <span v-if="item.database" class="item-base">{{ item.database }}</span>
                <span class="item-status">
                  <template v-if="getItemStatus(item.id) === 'running'">
                    <i class="el-icon-loading"></i> 运行中
                  </template>
                  <template v-else-if="getItemStatus(item.id) === 'completed'">
                    <i class="el-icon-circle-check"></i> 完成
                  </template>
                  <template v-else-if="getItemStatus(item.id) === 'failed'">
                    <i class="el-icon-circle-close"></i> 失败
                  </template>
                  <template v-else-if="getItemStatus(item.id) === 'pending'">
                    <i class="el-icon-time"></i> 等待中
                  </template>
                  <template v-else>
                    <i class="el-icon-minus"></i> 未选
                  </template>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleBatchKpiClose" :disabled="batchKpiRunning">
          {{ batchKpiJustFinished ? '关 闭' : '取 消' }}
        </el-button>
        <el-button
          v-if="!batchKpiRunning && !batchKpiJustFinished"
          type="primary"
          @click="submitBatchKpi"
          :loading="batchKpiSubmitting"
          :disabled="batchKpiForm.kids.length === 0"
        >
          <i class="el-icon-caret-right" v-if="!batchKpiSubmitting"></i>
          开始生成
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ReportList",
  props: ["pid", "pname", "pcode"],
  data() {
    return {
      doing: false,
      tableData: [],
      currentPage: 1,
      total: 1,
      downLoading: false,
      downType: '',
      chartImportDialogVisible: false,
      currentKid: null,
      uploadAction: '',
      uploadHeaders: {},
      showFileList: true,
      token: '',
      uploadLoading: false,
      clearLoading: { header: false, side: false },
      batchDialogVisible: false,
      batchLoading: false,
      batchDataLoading: false,
      batchQids: [],
      batchReports: [],
      batchForm: { qid: '', cpid: '' },
      batchKpiDialogVisible: false,
      batchKpiLoading: false,
      batchKpiSubmitting: false,
      batchKpiRunning: false,
      batchKpiReports: [],
      batchKpiForm: { kids: [] },
      batchKpiStatus: { total: 0, current: 0, currentKid: '', status: '', message: '' },
      batchKpiItemStatus: {},
      batchKpiJustFinished: false,
      batchKpiPollingTimer: null,
      checkAll: false,
    };
  },

  created() {
    this.getreport(this.currentPage);
  },
  computed: {
    isIndeterminate() {
      var len = this.batchKpiForm.kids.length;
      return len > 0 && len < this.batchKpiReports.length;
    },
    batchKpiFailedCount() {
      return this.batchKpiFailedKids.length;
    },
    batchKpiFailedKids() {
      if (!this.batchKpiStatus.message) return [];
      var failed = [];
      var msg = this.batchKpiStatus.message;
      var regex = /生成失败:\s*(\S+)\s*-/g;
      var match;
      while ((match = regex.exec(msg)) !== null) {
        failed.push(match[1]);
      }
      return failed;
    }
  },
  methods: {
    topage(t) {
      this.$router.push({
        name: t,
        params: { pid: this.pid, pname: this.pname, pcode: this.pcode },
      });
    },

    operate(op, name, kid) {
      let cpid = kid;
      let newname = name;
      switch (op) {
        case "新建":
          cpid = null;
          newname = null;
          break;
        case "复制":
          newname = name + "-副本";
          break;
      }
      this.$prompt("请输入reportal名称", op, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S+/,
        inputErrorMessage: "请输入非空字符",
        inputValue: newname,
      })
        .then(({ value }) => {
          if (op == "重命名") {
            this.rename(cpid, value);
          } else {
            this.add(cpid, value);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    add(cpid, name) {
      this.doing = true;
      var api = this.COMMON.httpUrl + "reportAdd";
      var data = {
        cpid: cpid,
        name: name,
        pid: this.pid,
        pname: this.pname,
      };
      this.axios.post(api, data).then((response) => {
        this.doing = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    rename(kid, name) {
      this.doing = true;
      var api = this.COMMON.httpUrl + "reportRename";
      var data = {
        kid: kid,
        name: name,
        pid: this.pid,
        pname: this.pname,
      };
      this.axios.post(api, data).then((response) => {
        this.doing = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    del(kid) {
      this.$confirm("删除后相关数据将被清除,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.rundel(kid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    rundel(kid) {
      this.doing = true;
      var api = this.COMMON.httpUrl + "reportDel";
      var data = {
        pid: this.pid,
        kid: kid,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        this.doing = false;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success("删除成功");
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    getreport(page) {
      var api = this.COMMON.httpUrl + "reportList";
      var data = {
        pid: this.pid,
        page: page,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    
    // 表头表侧相关方法
    operateChartImport(name, kid) {
      this.currentKid = kid;
      this.uploadAction = this.COMMON.httpUrl + 'kpiChartDataImport';
      this.token = 'Bearer ' + localStorage.getItem('token');
      this.uploadHeaders = {
        'Authorization': this.token        
      };
      this.chartImportDialogVisible = true;
    },
    
    handleChartImportClose() {
      this.chartImportDialogVisible = false;
      this.currentKid = null;
    },
    
    beforeAvatarUpload(file) {
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isXls = fileName === "xls";
      const isXlsx = fileName === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!(isXls || isXlsx)) {
        this.$message({
          message: "上传文件只能是 xls、xlsx格式!",
          type: "warning",
        });
        return false;
      }
      
      if (!isLt2M) {
        this.$message({
          message: "文件大小不能超过2MB!",
          type: "warning",
        });
        return false;
      }
    },
    
    submitUpload() {
      // 检查参数是否正确设置
      if (!this.pid || !this.currentKid) {
        this.$message.error('项目ID或报表ID不能为空');
        return;
      }
      
      // 检查是否选择了文件
      const uploadFiles = this.$refs.uploadRef.uploadFiles;
      if (!uploadFiles || uploadFiles.length === 0) {
        this.$message.warning('请先选择要上传的文件');
        return;
      }
      
      this.uploadLoading = true;
      this.$refs.uploadRef.submit();
    },
    
    clearHeader() {
      this.clearDimension(1, '表头');
    },
    
    clearSide() {
      this.clearDimension(2, '表侧');
    },
    
    clearDimension(weidu, typeName) {
      // 确认操作
      this.$confirm(`确定要清除${typeName}吗？此操作不可撤销。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 设置对应按钮的loading状态
        if (weidu === 1) {
          this.clearLoading.header = true;
        } else if (weidu === 2) {
          this.clearLoading.side = true;
        }
        // 发送请求到后端
        const api = this.COMMON.httpUrl + 'kpiChartDelete';
        const data = {
          pid: this.pid,
          kid: this.currentKid,
          weidu: weidu
        };
        
        this.axios.post(api, data).then((response) => {
          const rs = response.data;
          if (rs.code) {
            this.$message.error(rs.message || `清除${typeName}失败`);
          } else {
            this.$message.success(`${typeName}清除成功，删除了 ${rs.data.deleted_count} 条记录`);
          }
        }).catch((error) => {
          this.$message.error(`清除${typeName}请求失败`);
          console.error('Clear dimension error:', error);
        }).finally(() => {
          // 确保无论成功或失败都停止对应的loading
          if (weidu === 1) {
            this.clearLoading.header = false;
          } else if (weidu === 2) {
            this.clearLoading.side = false;
          }
        });
      }).catch(() => {
        // 用户取消操作
        this.$message.info(`已取消清除${typeName}`);
      });
    },
    
    handleUploadSuccess(response) {
      // 停止loading
      this.uploadLoading = false;
      // 检查后端返回的数据格式
      if (response && typeof response === 'object' && 'code' in response) {
        if (response.code > 0) {
          // code大于0表示有错误，显示错误信息
          this.$message.error(response.message || '上传失败');
        } else {
          // code等于0或小于0表示成功
          this.$message.success('上传成功');
          // 成功后清除上传列表
          this.$refs.uploadRef.clearFiles();
        }
      } else {
        // 如果响应格式不符合预期，则认为上传成功
        this.$message.success('上传成功');
        // 成功后清除上传列表
        this.$refs.uploadRef.clearFiles();
      }
    },
    
    handleUploadError(err) {
      this.uploadLoading = false;
      this.$message.error('上传失败');
      console.error('Upload error:', err);
    },

    // 批量创建reportal
    openBatchAdd() {
      this.batchForm = { qid: '', cpid: '' };
      this.batchQids = [];
      this.batchReports = [];
      this.batchDialogVisible = true;
      this.batchDataLoading = true;
      var api = this.COMMON.httpUrl + 'reportBatchAddInit';
      this.axios.post(api, { pid: this.pid }).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
          this.batchDialogVisible = false;
          return;
        }
        this.batchQids = rs.data.qids || [];
        this.batchReports = rs.data.reports || [];
      }).catch((error) => {
        this.$message.error('批量创建初始化请求失败');
        console.error('Batch add init error:', error);
        this.batchDialogVisible = false;
      }).finally(() => {
        this.batchDataLoading = false;
      });
    },
    handleBatchClose() {
      this.batchDialogVisible = false;
    },
    submitBatchAdd() {
      if (!this.batchForm.qid) {
        this.$message.warning('请选择数据筛选题目');
        return;
      }
      if (!this.batchForm.cpid) {
        this.$message.warning('请选择模板reportal');
        return;
      }
      this.batchLoading = true;
      var api = this.COMMON.httpUrl + 'reportBatchAdd';
      var data = {
        pid: this.pid,
        pname: this.pname,
        cpid: this.batchForm.cpid,
        qid: this.batchForm.qid,
      };
      this.axios.post(api, data).then((response) => {
        this.batchLoading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
          return;
        }
        this.$message.success(rs.message || '批量创建成功');
        this.tableData = rs.data.data;
        this.currentPage = rs.data.current_page;
        this.total = rs.data.total;
        this.batchDialogVisible = false;
      }).catch(() => {
        this.batchLoading = false;
        this.$message.error('批量创建请求失败');
      });
    },

    openBatchKpi() {
      this.batchKpiForm = { kids: [] };
      this.batchKpiStatus = { total: 0, current: 0, currentKid: '', status: '', message: '' };
      this.batchKpiItemStatus = {};
      this.batchKpiJustFinished = false;
      this.batchKpiDialogVisible = true;
      this.batchKpiLoading = true;
      this.stopBatchKpiPolling();

      var api = this.COMMON.httpUrl + 'kpiBatchStatus';
      this.axios.post(api, { pid: this.pid }).then((response) => {
        var rs = response.data;
        if (rs.code === 0 && rs.data && rs.data.status === 'running') {
          this.batchKpiStatus = rs.data;
          this.batchKpiRunning = true;
          this.startBatchKpiPolling();
        }
      }).catch(() => {}).finally(() => {
        this.batchKpiLoading = false;
      });

      var listApi = this.COMMON.httpUrl + 'reportList';
      this.axios.post(listApi, { pid: this.pid, page: 1 }).then((response) => {
        var rs = response.data;
        if (rs.code === 0) {
          this.batchKpiReports = rs.data.data || [];
        }
      }).catch(() => {});
    },

    handleBatchKpiClose() {
      this.stopBatchKpiPolling();
      this.batchKpiDialogVisible = false;
    },

    stopBatchKpiPolling() {
      if (this.batchKpiPollingTimer) {
        clearInterval(this.batchKpiPollingTimer);
        this.batchKpiPollingTimer = null;
      }
      this.batchKpiRunning = false;
    },

    startBatchKpiPolling() {
      this.batchKpiRunning = true;
      this.batchKpiItemStatus = {};
      var self = this;

      if (this.batchKpiPollingTimer) {
        clearInterval(this.batchKpiPollingTimer);
      }

      this.batchKpiPollingTimer = setInterval(function() {
        self.fetchBatchKpiStatus();
      }, 2000);

      self.fetchBatchKpiStatus();
    },

    fetchBatchKpiStatus() {
      var self = this;
      var api = this.COMMON.httpUrl + 'kpiBatchStatus';
      var params = new URLSearchParams();
      params.append('pid', this.pid);

      this.axios.post(api, params).then((response) => {
        var rs = response.data;
        if (rs.code === 0 && rs.data) {
          var prevKid = self.batchKpiStatus.currentKid;
          self.batchKpiStatus = rs.data;

          if (rs.data.completedKids && rs.data.completedKids.length > 0) {
            rs.data.completedKids.forEach(function(kid) {
              if (!self.batchKpiItemStatus[kid]) {
                self.$set(self.batchKpiItemStatus, kid, 'completed');
              }
            });
          }

          if (rs.data.failedKids && rs.data.failedKids.length > 0) {
            rs.data.failedKids.forEach(function(kid) {
              if (!self.batchKpiItemStatus[kid]) {
                self.$set(self.batchKpiItemStatus, kid, 'failed');
              }
            });
          }

          if (rs.data.currentKid && rs.data.currentKid !== prevKid) {
            if (prevKid && !self.batchKpiItemStatus[prevKid]) {
              self.$set(self.batchKpiItemStatus, prevKid, 'completed');
            }
          }
          if (rs.data.status === 'failed' && rs.data.currentKid) {
            self.$set(self.batchKpiItemStatus, rs.data.currentKid, 'failed');
          }

          if (rs.data.status === 'completed' || rs.data.status === 'failed') {
            self.stopBatchKpiPolling();
            self.batchKpiJustFinished = true;
            self.getreport(self.currentPage);
            if (self.batchKpiDialogVisible) {
              if (rs.data.status === 'completed') {
                self.$message.success('批量生成完成');
              } else {
                self.$message.error(rs.data.message || '部分生成失败');
              }
            }
          }
        } else if (rs.code && rs.message) {
          self.$message.error(rs.message);
        }
      }).catch((err) => {
        console.error('获取批量KPI状态失败:', err);
        self.$message.error('获取状态失败');
      });
    },

    submitBatchKpi() {
      if (this.batchKpiForm.kids.length === 0) {
        this.$message.warning('请选择要生成kpi的reportal');
        return;
      }
      this.batchKpiSubmitting = true;
      var api = this.COMMON.httpUrl + 'kpiBatchMake';
      var params = new URLSearchParams();
      params.append('pid', this.pid);
      params.append('kids', this.batchKpiForm.kids.join(','));

      this.axios.post(api, params).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
          this.batchKpiSubmitting = false;
          return;
        }
        this.$message.success('批量任务已启动');
        this.batchKpiSubmitting = false;
        this.startBatchKpiPolling();
      }).catch((err) => {
        console.error('启动批量KPI失败:', err);
        this.$message.error('启动批量KPI失败');
        this.batchKpiSubmitting = false;
      });
    },

    handleCheckAllChange(val) {
      this.batchKpiForm.kids = val ? this.batchKpiReports.map(item => item.id) : [];
    },

    batchDownKpi() {
      this.downLoading = true;
      this.downType = 'kpi';
      var api = this.COMMON.httpUrl + 'kpiBatchDownKpi';
      var params = new URLSearchParams();
      params.append('pid', this.pid);
      params.append('pname', this.pname);

      this.axios.post(api, params).then((response) => {
        var rs = response.data;
        this.downLoading = false;
        this.downType = '';
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          window.open(rs.data, '_blank');
          this.$message.success('下载链接已生成');
        }
      }).catch((err) => {
        console.error('下载kpi失败:', err);
        this.downLoading = false;
        this.downType = '';
        this.$message.error('下载失败');
      });
    },

    batchDownZuhe() {
      this.downLoading = true;
      this.downType = 'zuhe';
      var api = this.COMMON.httpUrl + 'kpiBatchDownZuhe';
      var params = new URLSearchParams();
      params.append('pid', this.pid);
      params.append('pname', this.pname);

      this.axios.post(api, params).then((response) => {
        var rs = response.data;
        this.downLoading = false;
        this.downType = '';
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          window.open(rs.data, '_blank');
          this.$message.success('下载链接已生成');
        }
      }).catch((err) => {
        console.error('下载组合题失败:', err);
        this.downLoading = false;
        this.downType = '';
        this.$message.error('下载失败');
      });
    },

    batchDownLoudou() {
      this.downLoading = true;
      this.downType = 'loudou';
      var api = this.COMMON.httpUrl + 'kpiBatchDownLoudou';
      var params = new URLSearchParams();
      params.append('pid', this.pid);
      params.append('pname', this.pname);

      this.axios.post(api, params).then((response) => {
        var rs = response.data;
        this.downLoading = false;
        this.downType = '';
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          window.open(rs.data, '_blank');
          this.$message.success('下载链接已生成');
        }
      }).catch((err) => {
        console.error('下载漏斗题失败:', err);
        this.downLoading = false;
        this.downType = '';
        this.$message.error('下载失败');
      });
    },

    getReportName(kid) {
      var report = this.batchKpiReports.find(function(item) { return item.id == kid; });
      return report ? report.name : kid;
    },

    getItemStatus(kid) {
      if (this.batchKpiItemStatus[kid]) {
        return this.batchKpiItemStatus[kid];
      }
      if (this.batchKpiRunning && kid == this.batchKpiStatus.currentKid) {
        return 'running';
      }
      var selected = this.batchKpiForm.kids.some(function(id) { return id == kid; });
      if (!selected) return '';
      if (this.batchKpiRunning) return 'pending';
      return '';
    },

    getItemStatusClass(kid) {
      var status = this.getItemStatus(kid);
      return 'item-' + (status || 'none');
    },
  },
};
</script>
  
<style scoped>
#content {
  background-color: white;
  width: 1200px;
  text-align: left;
  padding-left: 0px;
}

.op {
  padding: 20px 0;
}

.fenye {
  margin-top: 20px;
}
.open {
  margin-left: 15px;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  color: white;
  background-color: rgb(82 200 43);
}

span.moren {
  margin-left: 15px;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  color: white;
  background-color:#F56C6C;
}

.base-tag {
  display: inline-block;
  padding: 2px 8px;
  background-color: #f4f4f5;
  color: #909399;
  border-radius: 4px;
  font-size: 12px;
}

.no-base {
  color: #c0c4cc;
  font-size: 12px;
}
.caozuo {
  color: #409eff !important;
  margin-right: 15px;
}

/* 表头表侧弹窗样式 */
.upload-container {
  text-align: center;
}

.upload-area .el-upload__tip:last-child {
  margin-top: 10px;
  padding: 8px;
  background-color: #f4f4f5;
  border-radius: 4px;
  color: #606266;
}

.upload-area {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-area:hover {
  border-color: #409eff;
}

.upload-demo {
  display: inline-block;
  width: 100%;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.report-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
}

.report-item {
  display: block;
  margin-bottom: 8px;
  margin-left: 0 !important;
}

.report-item:last-child {
  margin-bottom: 0;
}

/* 批量生成KPI弹窗样式 */
.batch-kpi-dialog .el-dialog__body {
  padding: 15px 20px;
}

.batch-progress-panel {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.progress-header {
  margin-bottom: 4px;
}

.progress-stats {
  display: flex;
  gap: 24px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #303133;
  line-height: 1.2;
}

.stat-label {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.stat-success .stat-value {
  color: #67c23a;
}

.stat-danger .stat-value {
  color: #f56c6c;
}

.stat-primary .stat-value {
  color: #409eff;
}

.current-running {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #409eff;
  padding: 6px 0;
}

.current-running i {
  font-size: 16px;
}

.current-running strong {
  color: #303133;
}

.status-message {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 8px;
}

.status-message.status-completed {
  color: #67c23a;
  background: #f0f9eb;
}

.status-message.status-failed {
  color: #f56c6c;
  background: #fef0f0;
}

.batch-select-area {
  margin-top: 4px;
}

.select-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 6px 6px 0 0;
  border: 1px solid #ebeef5;
  border-bottom: none;
}

.select-count {
  font-size: 13px;
  color: #909399;
}

.select-count em {
  font-style: normal;
  color: #409eff;
  font-weight: 600;
}

.report-check-list {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 0 0 6px 6px;
  padding: 8px 12px;
}

.report-check-item {
  padding: 6px 0;
  border-bottom: 1px solid #f2f6fc;
}

.report-check-item:last-child {
  border-bottom: none;
}

.report-check-name {
  font-size: 13px;
  color: #303133;
}

.report-check-base {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 6px;
  background: #e1f3d8;
  color: #67c23a;
  border-radius: 3px;
  font-size: 11px;
  vertical-align: middle;
}

.empty-tip {
  text-align: center;
  padding: 30px 0;
  color: #c0c4cc;
  font-size: 13px;
}

.batch-status-list {
  margin-top: 12px;
}

.status-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 6px 6px 0 0;
  border: 1px solid #ebeef5;
  border-bottom: none;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}

.status-list-summary {
  font-weight: 400;
  font-size: 12px;
  color: #909399;
}

.status-list-body {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 0 0 6px 6px;
}

.status-list-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #f2f6fc;
  font-size: 13px;
  transition: background-color 0.2s;
}

.status-list-item:last-child {
  border-bottom: none;
}

.status-list-item:hover {
  background-color: #f5f7fa;
}

.item-index {
  width: 28px;
  color: #c0c4cc;
  font-size: 12px;
  flex-shrink: 0;
}

.item-name {
  flex: 1;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-base {
  margin: 0 12px;
  padding: 1px 6px;
  background: #e1f3d8;
  color: #67c23a;
  border-radius: 3px;
  font-size: 11px;
  flex-shrink: 0;
}

.item-status {
  flex-shrink: 0;
  font-size: 12px;
  min-width: 70px;
  text-align: right;
}

.item-running {
  background-color: #ecf5ff;
}

.item-running .item-status {
  color: #409eff;
}

.item-running .item-name {
  color: #409eff;
  font-weight: 500;
}

.item-completed .item-status {
  color: #67c23a;
}

.item-failed {
  background-color: #fef0f0;
}

.item-failed .item-status {
  color: #f56c6c;
}

.item-failed .item-name {
  color: #f56c6c;
}

.item-pending .item-status {
  color: #c0c4cc;
}

.item-none .item-status {
  color: #e4e7ed;
}

.item-none .item-name {
  color: #c0c4cc;
}

.item-none .item-index {
  color: #e4e7ed;
}
</style>